/**
 * Types for Branding Settings
 */

export type BrandingSettings = {
  collapsedLogoUrl: string;
  collapsedLogoUpdatedAt: string;
  fullLogoUrl: string;
  fullLogoUpdatedAt: string;
  faviconUrl: string;
  faviconUpdatedAt: string;
  defaultAvatarUrl: string;
  defaultAvatarUpdatedAt: string;
  defaultBannerUrl: string;
  defaultBannerUpdatedAt: string;
  emailLogoFullUrl: string;
  emailLogoFullUpdatedAt: string;
  emailLogoIconUrl: string;
  emailLogoIconUpdatedAt: string;
  // Computed URLs with cache busters
  resolvedCollapsedLogoUrl: string;
  resolvedFullLogoUrl: string;
  resolvedFaviconUrl: string;
  resolvedDefaultAvatarUrl: string;
  resolvedDefaultBannerUrl: string;
  resolvedEmailLogoFullUrl: string;
  resolvedEmailLogoIconUrl: string;
};

export type BrandingAssetType = "collapsedLogo" | "fullLogo" | "favicon" | "defaultAvatar" | "defaultBanner" | "emailLogoFull" | "emailLogoIcon";

export const BRANDING_ASSET_LABELS: Record<BrandingAssetType, string> = {
  collapsedLogo: "Collapsed Logo",
  fullLogo: "Full Logo",
  favicon: "Favicon",
  defaultAvatar: "Default Avatar",
  defaultBanner: "Default Profile Banner",
  emailLogoFull: "Email Logo (Full)",
  emailLogoIcon: "Email Logo (Icon)",
};

export const BRANDING_ASSET_DESCRIPTIONS: Record<BrandingAssetType, string> = {
  collapsedLogo: "Icon shown in the sidebar when collapsed (recommended: square, 64×64 or larger)",
  fullLogo: "Full logo shown in the sidebar (recommended: 200×50 or larger)",
  favicon: "Browser tab icon (recommended: .ico or 32×32 PNG)",
  defaultAvatar: "Fallback avatar for users without a custom profile picture",
  defaultBanner: "Fallback profile banner when a user has not uploaded one",
  emailLogoFull: "Wide logo displayed in outgoing email headers (recommended: 200\u00d750 or larger)",
  emailLogoIcon: "Square icon for compact email contexts (recommended: 64\u00d764 or larger)",
};

export const BRANDING_ASSET_ACCEPT: Record<BrandingAssetType, string> = {
  collapsedLogo: "image/png,image/jpeg,image/svg+xml,image/webp",
  fullLogo: "image/png,image/jpeg,image/svg+xml,image/webp",
  favicon: "image/x-icon,image/vnd.microsoft.icon,image/png",
  defaultAvatar: "image/png,image/jpeg,image/webp,image/gif",
  defaultBanner: "image/png,image/jpeg,image/webp,image/gif",
  emailLogoFull: "image/png,image/jpeg,image/svg+xml,image/webp",
  emailLogoIcon: "image/png,image/jpeg,image/svg+xml,image/webp",
};

export const DEFAULT_BRANDING: BrandingSettings = {
  collapsedLogoUrl: "",
  collapsedLogoUpdatedAt: "",
  fullLogoUrl: "",
  fullLogoUpdatedAt: "",
  faviconUrl: "",
  faviconUpdatedAt: "",
  defaultAvatarUrl: "",
  defaultAvatarUpdatedAt: "",
  defaultBannerUrl: "",
  defaultBannerUpdatedAt: "",
  resolvedCollapsedLogoUrl: "/uploads/brand/qb_logo_icon.svg",
  resolvedFullLogoUrl: "/uploads/brand/qb_logo_textsvg-01.svg",
  resolvedFaviconUrl: "/uploads/brand/favicon.ico",
  resolvedDefaultAvatarUrl: "/uploads/avatars/default_avatar.jpg",
  resolvedDefaultBannerUrl: "/uploads/brand/default_banner.svg",
  emailLogoFullUrl: "",
  emailLogoFullUpdatedAt: "",
  emailLogoIconUrl: "",
  emailLogoIconUpdatedAt: "",
  resolvedEmailLogoFullUrl: "",
  resolvedEmailLogoIconUrl: "",
};
